import React from 'react';
import LayerPopUp from 'components/atoms/LayerPopUp';

import { Btn, BtnRadio } from 'components';
import ZimssaConstant from 'commons/ZimssaConstant';
import { LABEL_SUBSCRIPTIONTYPE, BUTTON_CONFIRM } from 'commons/ZimssaString';

interface Props {
    isShow: boolean;
    isActive: boolean;
    state: string;
    onChangeItem: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClickConfirmed: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClickPopupAction: () => void;
}

function PopupSubscriptionType({ isShow, isActive, state, onChangeItem, onClickConfirmed, onClickPopupAction }: Props): React.ReactElement {
    const LayerPopUpProps = {
        width: 452,
        isShow: isShow,
        onClickPopupAction: onClickPopupAction,
        buttons: (
            <Btn
                height={52}
                color={isActive ? 'gray_opacity_50' : 'gray_opacity_300'}
                backGroundColor={isActive ? 'blue_900' : 'gray_opacity_200'}
                fontStyle={'body1_blod'}
                onClick={onClickConfirmed}
            >
                {BUTTON_CONFIRM}
            </Btn>
        ),
        labelProps: {
            contents: LABEL_SUBSCRIPTIONTYPE,
            fontStyle: 'title_bold',
            color: 'gray_opacity_800',
        },
    };

    return (
        <LayerPopUp {...LayerPopUpProps}>
            {ZimssaConstant.SUBSCRIPTION_TYPE.map((item, index) => (
                <BtnRadio key={index} btnType={'SUBSCRIPTION'} inputName={'subscriptionType'} height={56} contents={item} value={item} checked={item === state} onChange={onChangeItem} />
            ))}
        </LayerPopUp>
    );
}

export default PopupSubscriptionType;
